import { render, staticRenderFns } from "./CompaniesSubsTaskModal.vue?vue&type=template&id=de68bd76&scoped=true"
import script from "./CompaniesSubsTaskModal.vue?vue&type=script&lang=ts"
export * from "./CompaniesSubsTaskModal.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesSubsTaskModal.vue?vue&type=style&index=0&id=de68bd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de68bd76",
  null
  
)

export default component.exports